import React from 'react';
import UDIDropdownfield from "./UDIDropdownfield.js"

const WhatMRISafetyInformationDoesTheLabelingContain = ({
	UDI,
	setUDI,
	forceIsEditing = null
}) => {

	const fieldName = "WhatMRISafetyInformationDoesTheLabelingContain";
	const fieldTitle = "What MRI safety information does the labeling contain?";
	const LOV = [

		{ key: "", value: "" },
        { key: "Labeling does not contain MRI Safety Information", value: "Labeling does not contain MRI Safety Information" },
        { key: "MR Conditional", value: "MR Conditional" },
        { key: "MR Safe", value: "MR Safe" },
		{ key: "MR Unsafe", value: "MR Unsafe" },

	];

	return <>
		<UDIDropdownfield UDI={UDI} setUDI={setUDI} fieldTitle={fieldTitle} fieldName={fieldName} LOV={LOV} forceIsEditing={forceIsEditing} />
	</>											  
}


export default WhatMRISafetyInformationDoesTheLabelingContain;


